import { ConsoleColor, logData } from '../../utils/console.js';
export const getGtag = () => {
    if (!('gtag' in window) || typeof window.gtag !== 'function') {
        return undefined;
    }
    return window.gtag;
};
export const configureGtag = (options) => {
    const gtag = getGtag();
    if (!gtag) {
        return;
    }
    gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'granted',
    });
    gtag('consent', 'update', {
        ad_storage: options.consent.googleAnalyticsAdStorage ? 'granted' : 'denied',
        ad_user_data: options.consent.googleAnalyticsAdUserData ? 'granted' : 'denied',
        ad_personalization: options.consent.googleAnalyticsAdPersonalization ? 'granted' : 'denied',
        analytics_storage: 'granted',
    });
    // Set the current client date-time used for setting the GA cookie duration.
    gtag('js', new Date());
    /**
     * Specify a known identifier for a user provided by the site owner/library user.
     * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/config#user_id
     */
    gtag('set', 'user_id', options.userId);
    /**
     * Indicate whether advertising personalization features should be enabled.
     * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/config#allow_ad_personalization_signals
     */
    gtag('set', 'allow_ad_personalization_signals', options.consent.googleAllowAdPersonalizationSignals);
    // Add additional configuration information to the target.
    gtag('config', options.trackingId, {
        // Directly send a pageview event.
        send_page_view: true,
        // Configure the user properties.
        user_properties: options.userProperties,
    });
};
export const trackEvent = (event) => {
    const gtag = getGtag();
    if (!gtag) {
        return undefined;
    }
    gtag('event', event.name, {
        ...event.params,
        // Log event triggers to the console.
        event_callback: (tagId) => logData(`Event sent (GTAG - ${tagId !== null && tagId !== void 0 ? tagId : 'n/a'})`, event.name, event, ConsoleColor.EVENT),
    });
};
//# sourceMappingURL=gtag.js.map